import React from 'react';

import { PrismicRichText } from 'types/prismicRichtext';
import { Prismic_Person } from 'types/prismic';
import { PrismicImage } from 'types/prismicImage';
import { PrismicPeopleFields } from 'types/prismicSlices';

import { asText } from 'components/rich-text/RichText';
import { Grid } from 'components/grid/Grid';
import { PersonCard } from 'components/person-card/PersonCard';

import { ImageContainer } from './ImageContainer';
import { Placeholder } from 'components/placeholder/Placeholder';
import { PlaceholderColor, DefaultPlaceholderColor } from '../../types/placeholderColors';

interface IPeopleContainer {
  title: PrismicRichText;
  images: boolean;
  items: PrismicPeopleFields[];
  isColumnLayout: boolean;
  color?: PlaceholderColor;
}

export const PeopleContainer = ({
  title,
  items,
  isColumnLayout,
  color = DefaultPlaceholderColor,
}: IPeopleContainer) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <Grid isColumnLayout={isColumnLayout} heading={title ? asText(title) : undefined}>
      {items.map((item: PrismicPeopleFields, i: number) => {
        const person = (item?.person ?? null) as Prismic_Person;

        if (!person) {
          return null;
        }

        const name = asText(person?.name);
        const email = asText(person?.email);
        const tel = asText(person?.telephone);
        const image: PrismicImage = person?.portrait_image;
        const role = asText(person?.title);

        return (
          <PersonCard
            key={i}
            name={name}
            tel={tel}
            email={email}
            image={
              image ? <ImageContainer image={image} imageOnly /> : <Placeholder color={color} />
            }
            role={role}
          />
        );
      })}
    </Grid>
  );
};
